import React from 'react';
import ReactDOM from 'react-dom/client';
import { AppWithProviders } from './App';

const root = ReactDOM.createRoot(document.getElementById('root') as Element);
root.render(
  <React.StrictMode>
    <AppWithProviders />
  </React.StrictMode>
);
